import { useQuery } from "react-query";
import { getMapImage } from "../APIs/ggs";

const useNavigation = () => {
  const { data: map } = useQuery("get-map-image", getMapImage);

  return { mapUrl: map?.img ? `data:image/png;base64,${map.img}` : undefined };
};

export default useNavigation;
